'use client';
import { AuthButton } from '../AuthButton/AuthButton';
import styles from './AuthPromoCard.module.css';
import { ReactNode } from 'react';

interface StatsCardProps {
	icon: ReactNode;
	label: string;
	value: string;
}

interface AuthPromoCardProps {
	imageSrc: string;
	imageAlt?: string;
	title: string;
	description: string;
	statsCard: StatsCardProps;
}

export const AuthPromoCard = ({
	imageSrc,
	imageAlt = 'Café',
	title,
	description,
	statsCard,
}: AuthPromoCardProps) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.card}>
				<div className={styles.content}>
					<div className={styles.contentText}>
						<h3 className={styles.title}>{title}</h3>
						<p className={styles.description}>{description}</p>
					</div>
					<div className={styles.buttonWrapper}>
						<AuthButton variant="secondary" className={styles.button} type="button">
							Saber mais
						</AuthButton>
					</div>
				</div>

				<div className={styles.imageContainer}>
					<img src={imageSrc} alt={imageAlt} className={styles.image} />
				</div>
			</div>

			<div className={styles.statsCard}>
				<div className={styles.statsIcon}>{statsCard.icon}</div>
				<div className={styles.statsContent}>
					<span className={styles.statsLabel}>{statsCard.label}</span>
					<span className={styles.statsValue}>{statsCard.value}</span>
				</div>
			</div>
		</div>
	);
};
